// extracted by mini-css-extract-plugin
export default {"root":"Shortcut_root__seAFg","icon":"Shortcut_icon__uYodq","text":"Shortcut_text__rB0NF"};